document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-lp-bundle-goals-toggle-content').forEach((el) => {
    el.addEventListener('click', () => {
      const content = el.parentNode.querySelector('.mo-boxes');
      if (content.classList.contains('hidden')) {
        content.classList.remove('hidden');
        el.querySelector('.mo-plus').classList.add('mo-hide');
        el.querySelector('.mo-minus').classList.remove('mo-hide');
      } else {
        content.classList.add('hidden')
        el.querySelector('.mo-plus').classList.remove('mo-hide');
        el.querySelector('.mo-minus').classList.add('mo-hide');
      }
    });
  });

  document.querySelectorAll('.js-atc-click').forEach((el) => {
    el.addEventListener('click', () => {
      ga('send', 'event', 'atc_click', 'add_to_cart', 'LP');  
    });
  });


});